import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { CoordinatesShape } from 'constants/shapes';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { VenueCarousel } from 'components/VenueCarousel/VenueCarousel';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { ga } from 'helpers/multitrack';
import { selectIsMobile } from 'redux/modules/device';
import { selectUserLocation } from 'redux/modules/locale';
import { nearbyPopularVenues } from 'redux/saga/entities/bound';
import { filterValidVenues, loadVenues, nearbyVenuesKey, watchSaga } from './visitableVenues.saga';
import { VerticalVenueList } from './VerticalVenueList';
var MIN_DISPLAY_VENUES = 4;
export var VisitableVenuesUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(VisitableVenuesUnwrapped, _Component);

  function VisitableVenuesUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VisitableVenuesUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VisitableVenuesUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleCtaClick = _this.handleCtaClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VisitableVenuesUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var coordinates = this.props.coordinates;
      this.props.loadVenues(coordinates);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var coordinates = this.props.coordinates || {};
      var prevLocation = prevProps.coordinates || {};

      if (prevLocation.lat !== coordinates.lat || prevLocation.lon !== coordinates.lon) {
        this.props.loadVenues(coordinates);
      }
    }
  }, {
    key: "handleCtaClick",
    value: function handleCtaClick() {
      ga('Studios Module', 'Clicked Explore all studios');
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var _this$props = this.props,
          isClickable = _this$props.isClickable,
          venues = _this$props.venues;
      return React.createElement("div", {
        className: "venues__carousel"
      }, React.createElement(VenueCarousel, {
        elements: venues,
        nolink: !isClickable,
        showCount: true
      }));
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var venues = this.props.venues;
      return React.createElement("div", {
        className: "venues__list"
      }, React.createElement(VerticalVenueList, {
        elements: venues,
        showCount: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          backgroundColor = _this$props2.backgroundColor,
          extraClassNames = _this$props2.extraClassNames,
          header = _this$props2.header,
          showAsList = _this$props2.showAsList,
          subheader = _this$props2.subheader,
          venues = _this$props2.venues;
      return venues.length >= MIN_DISPLAY_VENUES && React.createElement("div", {
        className: "bg--".concat(backgroundColor || 'white')
      }, React.createElement(Section, {
        className: classNames('venues', extraClassNames)
      }, React.createElement(Heading, {
        className: "venues__title"
      }, header || React.createElement(FormattedMessage, {
        id: "visitable-venues.title",
        defaultMessage: "Studios you can visit"
      })), subheader && React.createElement("p", {
        className: "venues__subtitle"
      }, subheader), showAsList ? this.renderList() : this.renderCarousel(), React.createElement("div", {
        className: "text--center"
      }, React.createElement(Link, {
        to: "/search",
        className: "bt bt--primary bt--outline bt--lg",
        onClick: this.handleCtaClick
      }, React.createElement(FormattedMessage, {
        id: "visitable-venues.cta",
        defaultMessage: "Explore all studios"
      })))));
    }
  }]);

  return VisitableVenuesUnwrapped;
}(Component);
export var mapDispatchToProps = {
  loadVenues: loadVenues
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var isMobile = selectIsMobile(state);
  var coordinates = props.coordinates || selectUserLocation(state);

  var _ref = nearbyPopularVenues.data(state, nearbyVenuesKey(coordinates)) || {
    venues: []
  },
      venues = _ref.venues;

  return {
    coordinates: coordinates,
    showAsList: !!(isMobile && props.canShowVerticalViewInMobile),
    venues: filterValidVenues(venues)
  };
};
VisitableVenuesUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  coordinates: CoordinatesShape,
  extraClassNames: PropTypes.string,
  header: PropTypes.node,
  isClickable: PropTypes.bool,
  loadVenues: PropTypes.func.isRequired,
  showAsList: PropTypes.bool.isRequired,
  subheader: PropTypes.string,
  venues: PropTypes.array
};
export var VisitableVenues = decorateWith(withSagas({
  watch: watchSaga
}), connect(mapStateToProps, mapDispatchToProps), withName('VisitableVenues'))(VisitableVenuesUnwrapped);